/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {
    apiUrl,
    getEnumParams,
    handleApiCall,
    securedApiOptions
} from './HttpUtils'

const getUIconfigUrl = () => {
    return apiUrl(`uiConfig`)
}

export const getUIconfigs = (names) => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    const UIconfigs = '?' + getEnumParams('uiConfig', names)
    return handleApiCall(getUIconfigUrl() + UIconfigs, opts)
}

export const getAllUIconfigs = () => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getUIconfigUrl() + '/all', opts)
}

export const setUIconfig = (name, status) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(getUIconfigUrl() + '/?uiConfig=' + name + '&status=' + status, opts)
}

export const UIconfigNames = {
    TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED: 'TESTS_AND_CORRECTIVE_ACTIONS_SEPARATED',
    ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD: 'ONLY_ONE_CA_WITH_POSITIVE_LIKELIHOOD',
    WE_ARE_SORRY_MESSAGE: 'WE_ARE_SORRY_MESSAGE',
    ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON: 'ASSIGN_FAULT_TO_USER_TROUBLESHOOTING_BUTTON',
    ALLOW_JUST_ONE_SYMPTOM_TO_REPORT: 'ALLOW_JUST_ONE_SYMPTOM_TO_REPORT',
    JUMP_DIRECTLY_TO_OBSERVATIONS: 'JUMP_DIRECTLY_TO_OBSERVATIONS',
    SHOW_NEW_FAULT_DISCLAIMER: 'SHOW_NEW_FAULT_DISCLAIMER',
    SHOW_CAUSES_IN_CA_ACTION_DETAIL: 'SHOW_CAUSES_IN_CA_ACTION_DETAIL',
    LDI_IMPORT_KEEP_FAULTS: 'LDI_IMPORT_KEEP_FAULTS'
}